import {TicketTypeService} from "./service/api/ticket-type.service";
import {TicketTypeActionService} from "./service/api/ticket-type-action.service";
import {TicketService} from "./service/api/ticket.service";
import {TicketActionService} from "./service/api/ticket-action.service";
import {TicketActionCommentService} from "./service/api/ticket-action-comment.service";
import {TicketAppointmentService} from "./service/api/ticket-appointment.service";
import {TicketRelTicketService} from "./service/api/ticket-rel-ticket.service";
import {TicketStatusService} from "./service/api/ticket-status.service";
import {TicketGroupFilterSelectionUrgencyService} from "./service/api/ticket-group-filter-selection-urgency.service";
import {TicketGroupFilterSelectionStatusService} from "./service/api/ticket-group-filter-selection-status.service";
import {
    TicketGroupFilterRestrictionAgentPoolService
} from "./service/api/ticket-group-filter-restriction-agent-pool.service";
import {
    TicketGroupFilterSelectionTicketGroupService
} from "./service/api/ticket-group-filter-selection-ticket-group.service";
import {TicketGroupFilterRestrictionAgentService} from "./service/api/ticket-group-filter-restriction-agent.service";
import {TicketGroupFilterService} from "./service/api/ticket-group-filter.service";
import {TicketGroupFilterSelectionAgentService} from "./service/api/ticket-group-filter-selection-agent.service";
import {
    TicketGroupFilterSelectionAgentPoolService
} from "./service/api/ticket-group-filter-selection-agent-pool.service";
import {
    TicketGroupFilterSelectionTicketTypeService
} from "./service/api/ticket-group-filter-selection-ticket-type.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {MvsCrudModeEnum} from "../../core/shared/service/crud/mvs-crud-mode.enum";
import {TicketComponent} from "./component/protected-components/ticket/ticket.component";
import {
    TicketQuickCreateComponent
} from "./component/protected-components/ticket-quick-create/ticket-quick-create.component";
import {
    TmTicketCreateConsultantComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket-create/tm-ticket-create-consultant.component";
import {
    TmTicketConsultantComponent
} from "./component/protected-components/ticket/ticket-components/tm-ticket/tm-ticket-consultant.component";
import {MvsTicketComponent} from "../../core/shared/ticket/component/mvs-ticket/mvs-ticket.component";
import {
    ObjectTicketGroupFilterComponent
} from "./component/protected-components/object-ticket-group-filter/object-ticket-group-filter.component";
import {
    TicketFilterGroupListComponent
} from "./component/protected-components/ticket-management/components/ticket-filter-group-list-component/ticket-filter-group-list.component";

export const TM_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['tm.TicketGroup', {route: '/tm/ticketGroups'}],

            ['tm.TicketType', {route: '/tm/ticketTypes', service: TicketTypeService}],
            ['tm.TicketTypeAction', {route: 'tm/none', service: TicketTypeActionService}],
            ['tm.TicketTypeField', {route: '/tm/ticketTypeFields'}],
            ['tm.TicketTypeObjectType', {route: '/tm/ticketTypeObjectTypes'}],

            ['tm.TicketTypeCompleteStatus', {route: '/tm/ticketTypeCompleteStatuss'}],
            ['tm.TicketTypeActionProcessMapping', {route: '/tm/ticketTypeActionProcessMappings'}],
            ['tm.TicketTypeActionTicketMapping', {route: '/tm/ticketTypeActionTicketMappings'}],

            ['tm.Ticket', {
                route: '/tm/tickets',
                service: TicketService,
                objectComponent: [
                    {mode: MvsCrudModeEnum.create, viewType: 'consultant', component: TmTicketCreateConsultantComponent},
                    {viewType: 'consultant', component: TmTicketConsultantComponent},
                    {mode: MvsCrudModeEnum.create, component: TicketQuickCreateComponent},
                    {component: TicketComponent},
                ],
                objectListComponent: [
                    {component: MvsTicketComponent},
                ]
            }],
            ['tm.TicketAction', {route: 'tm/none', service: TicketActionService}],
            ['tm.TicketActionComment', {route: 'tm/none', service: TicketActionCommentService}],
            ['tm.TicketObject', {route: '/tm/ticketObjects'}],
            ['tm.TicketAttachment', {route: 'about:blank'}],
            ['tm.TicketAppointment', {route: 'tm/none', service: TicketAppointmentService}],
            ['tm.TicketComment', {route: '/tm/ticketComments'}],
            ['tm.TicketWatchList', {route: '/tm/ticketWatchLists'}],
            ['tm.TicketRelTicket', {route: 'tm/none', service: TicketRelTicketService}],
            ['tm.TicketTag', {route: '/tm/ticketTags'}],
            ['tm.TicketStatus', {route: 'tm/none', service: TicketStatusService}],

            ['tm.TicketGroupFilterSelectionUrgency', {route: '/tm/ticketGroupFilterSelectionUrgencys', service: TicketGroupFilterSelectionUrgencyService}],
            ['tm.TicketTypeNotificationTypeMapping', {route: '/tm/ticketTypeNotificationTypeMappings'}],
            ['tm.TicketGroupFilterSelectionStatus', {route: '/tm/ticketGroupFilterSelectionStatuss', service: TicketGroupFilterSelectionStatusService}],

            ['tm.TicketGroupFilterRestrictionAgentPool', {
                route: '/tm/ticketGroupFilterRestrictionAgentPools',
                service: TicketGroupFilterRestrictionAgentPoolService
            }],
            ['tm.TicketGroupFilterSelectionTicketGroup', {
                route: '/tm/ticketGroupFilterSelectionTicketGroups',
                service: TicketGroupFilterSelectionTicketGroupService
            }],
            ['tm.TicketGroupFilterRestrictionAgent', {route: '/tm/ticketGroupFilterRestrictionAgents', service: TicketGroupFilterRestrictionAgentService}],
            ['tm.TicketGroupFilter', {
                route: '/tm/ticketGroupFilters',
                service: TicketGroupFilterService,
                objectComponent: [{component: ObjectTicketGroupFilterComponent}],
                objectListComponent: [{component: TicketFilterGroupListComponent}],
            }],
            ['tm.TicketGroupFilterSelectionAgent', {route: '/tm/ticketGroupFilterSelectionAgents', service: TicketGroupFilterSelectionAgentService}],
            ['tm.TicketGroupFilterSelectionAgentPool', {
                route: '/tm/ticketGroupFilterSelectionAgentPools',
                service: TicketGroupFilterSelectionAgentPoolService
            }],
            ['tm.TicketGroupFilterSelectionTicketType', {
                route: '/tm/ticketGroupFilterSelectionTicketTypes',
                service: TicketGroupFilterSelectionTicketTypeService
            }],

            ['tm.TicketObjectMain', {route: '/tm/ticketObjectMains'}],
            ['tm.TicketBaseStatistic', {route: '/tm/ticketBaseStatistic'}],
            ['tm.TicketData', {route: '/tm/ticketDatas'}],

            ['tm.TicketField', {route: '/tm/ticketFields'}],
            ['tm.TmCommunicationChannel', {route: '/tm/communicationChannels'}],
            ['tm.TicketTypeNotificationType', {route: '/tm/ticketTypeNotificationTypes'}],
            ['tm.TicketCommentEu', {route: '/tm/ticketCommentEus'}],
            ['tm.TicketGroupObjectType', {route: '/tm/ticketGroupObjectTypes'}],
            ['tm.TicketTypeObjectRole', {route: '/tm/ticketTypeObjectRoles'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
